/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * @module bulb-block-id/bulbblockid
 */

// eslint-disable-next-line import/no-extraneous-dependencies
import { Plugin } from 'ckeditor5';
import BulbBlockIdEditing from './bulbblockidediting';

/**
 * Plugin to add bulb-id for elements like p, li, blockquote, etc.
 *
 * @extends Plugin
 */
export default class BulbBlockId extends Plugin {

  /**
   * @inheritDoc
   */
  public static get requires() {
    return [BulbBlockIdEditing] as const;
  }

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbBlockId' as const;
  }
}
